import { Component, OnInit, ViewChild } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ToastController } from '@ionic/angular';
import { NaploService } from '../naplo.service';
import { DataService } from '../../data.service';
import { Router } from '@angular/router';
import { KeretService } from '../../keret.service';
import { modeFavicon } from '../../mode-nevek';
import { BevallasPdfComponent } from '../../nav-nyomtatvany/bevallas-pdf/bevallas-pdf.component';

// NAPLO – Munkaterv: cégenként milyen nyomtatványt kell BEADNI az adott (beadási) hónapban és
// megtörtént-e. A tárgyidőszak az előző periódus (havi/negyedéves/éves). Ügyfél-független nézet.
// Két nézet: "cégenként" (soronként egy cég feladatai) és "nyomtatványonként" (fordított – egy
// nyomtatvány + az érintett cégek). Állapotok: Beadva / Nyugta / Email / Offline – külön pipával.
// BEFIZETÉSI ÉRTESÍTŐ (backend/naplo-befizetes.js): cégenként vagy tömegesen levél az ügyfélnek a hónap
// befizetendőiről (az elkészült bevallásokból, NAV-számlaszámmal), bér-mellékletekkel; küldés után az
// Email oszlop kipipálódik.
@Component({
  selector: 'app-naplo-munkaterv',
  templateUrl: './munkaterv.component.html',
  styleUrls: ['../naplo-shared.scss', './munkaterv.component.scss'],
})
export class MunkatervComponent implements OnInit {
  ev = new Date().getFullYear();
  ho = new Date().getMonth() + 1;
  honapok = Array.from({ length: 12 }, (_, i) => i + 1);
  terv: any = { osszes: 0, kesz: 0, hatra: 0, sorok: [] };
  csakHatra = false;
  nezet: 'ceg' | 'nyomtatvany' = 'ceg';
  szurtSablon = '';                 // fordított nézet: egy nyomtatványra szűrés ('' = mind)
  /*  NAV-ELLENŐRZÉS. A munkaterv az intézmény ÖSSZES cégét mutatja, a NAV gépi lekérdezése
   *  viszont cégenként megy: ez a gomb végigkérdezi azokat, ahol a NAV-kapcsolat (M2M) be van
   *  állítva, és a válasz (mit hiányol a NAV) a sorok mellett jelenik meg. */
  navFut = false;
  navHalad: any = null;

  // állapot-mező → [flag, dátum] property nevek a feladat-objektumon
  private readonly FLAG: Record<string, [string, string]> = {
    beadva: ['teljesitve', 'teljesitve_datum'],
    nyugta: ['nyugta', 'nyugta_datum'],
    email: ['email', 'email_datum'],
    offline: ['offline', 'offline_datum'],
  };

  /** A magától pipált (tárhelyről érkezett nyugta) jelölés magyarázata. */
  autoCim(f: any): string {
    return `A tárhelyről letöltött NAV-nyugta alapján (érkeztetőszám: ${f.nyugta_erkezteto || '—'}) – a bevallásokhoz kötve, kézzel nem kell jelölni.`;
  }

  constructor(private naplo: NaploService, private toast: ToastController, private data: DataService, private sanitizer: DomSanitizer,
              private router: Router, private keret: KeretService) {}

  /** A beadott bevallás megnyitása nyomtatásra (BÉR-bevallásnál a Bér alrendszerben). */
  /*  A beadott bevallás PDF-ként, új lapon – a kitöltő és a nyomtatóablak nélkül (user, 2026-10-07):
   *  a lapképet a háttérben rendereljük, a PDF-et a kiszolgáló készíti (BevallasPdfComponent). */
  @ViewChild('bevallasPdf') bevallasPdf?: BevallasPdfComponent;
  pdfFut: string | null = null;
  async bevallasNyit(b: { id: string; kod: string; modul: string }) {
    if (!this.bevallasPdf || this.pdfFut) return;
    this.pdfFut = b.id;
    try { await this.bevallasPdf.megnyit({ id: b.id, kod: b.kod }); }
    catch (e: any) { this.uzen(e?.message || 'Nem sikerült elkészíteni a PDF-et.', true); }
    finally { this.pdfFut = null; }
  }
  get pdfLogo() { return modeFavicon('NAPLO'); }
  m2mIgazolas(b: { id: string }) {
    this.data.megnyitFajl(`/api/nav-nyomtatvany/bevallas/${b.id}/m2m-igazolas.pdf`, 'Igazolás a gépi beküldésről');
  }

  /* ── Befizetési értesítő ── */
  private readonly bef = '/api/naplo-befizetes';
  /** Egy cég levele (előnézet, szerkesztés, küldés). */
  level: any = null;
  levelHtml: SafeHtml | null = null;
  levelFut = false;
  /** Tömeges küldés: a hónap cégei. */
  tomeges: any = null;
  tomegesFut = false;
  mellek = { berlista: true, atutalas: true, jarulek: true };

  async levelNyit(ugyfelId: string) {
    this.levelHtml = null;
    try {
      const a: any = await this.naplo.getAbs(`${this.bef}/elonezet/${ugyfelId}?ev=${this.ev}&ho=${this.ho}`);
      this.level = { ...a, cimzett: a.ugyfel.email, tetelek: a.tetelek.map((t: any) => ({ ...t })), mellek: { ...this.mellek } };
    } catch (e: any) { this.uzen(e?.error?.error || 'Nem sikerült összeállítani.', true); }
  }
  abs(n: number): number { return Math.abs(Number(n) || 0); }
  get levelOsszeg(): number { return (this.level?.tetelek || []).reduce((n: number, t: any) => n + (Number(t.osszeg) > 0 ? Number(t.osszeg) : 0), 0); }
  sorTorol(t: any) { this.level.tetelek = this.level.tetelek.filter((x: any) => x !== t); this.levelHtml = null; }
  sorUj() { this.level.tetelek.push({ bevallas: '', idoszak: '', adonem: '', osszeg: null, hatarido: '', forras: 'kezi' }); this.levelHtml = null; }
  private levelTorzs() {
    const l = this.level;
    return { ev: this.ev, ho: this.ho, cimzett: l.cimzett, targy: l.targy, szoveg: l.szoveg, tetelek: l.tetelek, mellekletek: l.mellek };
  }
  async levelElonezet() {
    try {
      const r: any = await this.naplo.postAbs(`${this.bef}/level-elonezet/${this.level.ugyfel.id}`, this.levelTorzs());
      this.levelHtml = this.sanitizer.bypassSecurityTrustHtml(r.html);   // a kiszolgáló minden adatot escape-elt
    } catch (e: any) { this.uzen(e?.error?.error || 'Nem sikerült az előnézet.', true); }
  }
  pdfNyit(fajta: string) {
    this.data.megnyitFajl(`${this.bef}/pdf/${this.level.ugyfel.id}/${fajta}?ev=${this.ev}&ho=${this.ho}`, fajta);
  }
  async levelKuld() {
    if (this.levelFut) return;
    this.levelFut = true;
    try {
      const r: any = await this.naplo.postAbs(`${this.bef}/kuld/${this.level.ugyfel.id}`, this.levelTorzs());
      this.uzen(`Elküldve: ${r.cimzett} – ${r.tetel_db} tétel, ${Number(r.osszeg).toLocaleString('hu-HU')} Ft${r.mellekletek?.length ? `, ${r.mellekletek.length} melléklet` : ''}.`);
      this.level = null;
      await this.betolt();
      if (this.tomeges) await this.tomegesFrissit();
    } catch (e: any) { this.uzen(e?.error?.error || 'Nem sikerült elküldeni.', true); }
    finally { this.levelFut = false; }
  }

  async tomegesNyit() { this.tomeges = { ugyfelek: [], betolt: true }; await this.tomegesFrissit(); }
  async tomegesFrissit() {
    try {
      const r: any = await this.naplo.getAbs(`${this.bef}/lista/${encodeURIComponent(this.intezmeny)}?ev=${this.ev}&ho=${this.ho}`);
      //  Alapból kijelölve: van e-mail címe és befizetendője, és ebben a hónapban még nem kapott levelet.
      this.tomeges = { ugyfelek: r.ugyfelek.map((u: any) => ({ ...u, jelolt: !!u.email && u.osszeg > 0 && !u.kuldve })), betolt: false };
    } catch (e: any) { this.uzen(e?.error?.error || 'Nem sikerült összeállítani.', true); this.tomeges = null; }
  }
  get tomegesJelolt(): any[] { return (this.tomeges?.ugyfelek || []).filter((u: any) => u.jelolt); }
  async tomegesKuld() {
    const idk = this.tomegesJelolt.map((u: any) => u.ugyfel_id);
    if (!idk.length || this.tomegesFut) return;
    this.tomegesFut = true;
    try {
      const r: any = await this.naplo.postAbs(`${this.bef}/kuld-tomeges/${encodeURIComponent(this.intezmeny)}`,
        { ev: this.ev, ho: this.ho, ugyfelek: idk, mellekletek: this.mellek });
      const hibak = (r.eredmeny || []).filter((x: any) => !x.ok).map((x: any) => x.hiba);
      this.uzen(`${r.kuldve} levél elküldve${r.hibas ? `, ${r.hibas} nem ment ki: ${hibak.slice(0, 3).join('; ')}` : ''}.`, !!r.hibas);
      await this.betolt();
      await this.tomegesFrissit();
    } catch (e: any) { this.uzen(e?.error?.error || 'Nem sikerült.', true); }
    finally { this.tomegesFut = false; }
  }

  get intezmeny() { return this.naplo.aktiv.intezmeny; }

  async ngOnInit() {
    await this.naplo.init();
    await this.betolt();
  }

  async betolt() {
    if (!this.intezmeny) return;
    try {
      this.terv = await this.naplo.get('/munkaterv/' + encodeURIComponent(this.intezmeny) + '?ev=' + this.ev + '&ho=' + this.ho);
    } catch { this.terv = { osszes: 0, kesz: 0, hatra: 0, sorok: [] }; }
  }

  /** Végigkérdezi a NAV-ot minden olyan cégnél, ahol a NAV-kapcsolat be van állítva. */
  async navEllenorzes() {
    if (!this.intezmeny || this.navFut) return;
    this.navFut = true;
    try {
      const id = await this.naplo.feladatIndit('/munkaterv/' + encodeURIComponent(this.intezmeny) + '/nav-frissites', {});
      if (!id) { this.uzen('Nem sikerült elindítani a NAV-ellenőrzést.', true); return; }
      const f = await this.naplo.feladatVar(id, (h) => { this.navHalad = h; });
      this.navHalad = null;
      const e = f?.eredmeny || {};
      await this.betolt();
      this.uzen(`NAV-ellenőrzés kész: ${e.lekert || 0} cég lekérdezve`
        + (e.kihagyva_db ? `, ${e.kihagyva_db} kihagyva (nincs NAV-kapcsolat)` : '')
        + (e.hibak?.length ? `, ${e.hibak.length} hibával` : '') + '.');
    } catch (e: any) { this.uzen(e?.error?.error || 'A NAV-ellenőrzés nem sikerült.', true); }
    finally { this.navFut = false; this.navHalad = null; }
  }
  /** Egy cég NAV-állapota a sorhoz (mit hiányol a NAV). */
  navAllapot(sor: any): string {
    const n = sor?.nav;
    if (!n) return '';
    if (n.hianyzo_db) return `${n.hianyzo_db} hiányzó bevallás a NAV szerint`;
    if (n.allapot === 'NINCS_ADAT') return 'a NAV nem hiányol bevallást';
    return n.allapot || '';
  }
  private async uzen(m: string, hiba = false) {
    (await this.toast.create({ message: m, duration: hiba ? 4200 : 2600, color: hiba ? 'danger' : 'success' })).present();
  }

  async valt(ev?: number | null, ho?: number | null) {
    if (ev != null) this.ev = ev;
    if (ho != null) this.ho = ho;
    await this.betolt();
  }

  /*  A NÉZETEK SORAI TÁROLVA (2026-11-05): a három getter minden változásészleléskor új tömböket adott, az *ngFor ezért
   *  a teljes tervet újraépítette. Csak akkor számolunk újra, ha a terv, a szűrők vagy egy pipa (valtozas) változik. */
  private valtozas = 0;
  private nezetTar = new Map<string, { k: any[]; v: any }>();
  private tarolva<T>(nev: string, k: any[], fn: () => T): T {
    const t = this.nezetTar.get(nev);
    if (t && t.k.length === k.length && t.k.every((x, i) => x === k[i])) return t.v;
    const v = fn();
    this.nezetTar.set(nev, { k, v });
    return v;
  }

  // A terven szereplő nyomtatványok (a szűrő legördülőhöz) – egyedi sablon_kod+név.
  get sablonLista() { return this.tarolva('sablon', [this.terv], () => this.sablonListaSzamol()); }
  private sablonListaSzamol() {
    const m = new Map<string, string>();
    for (const sor of (this.terv.sorok || [])) for (const f of sor.feladatok) if (!m.has(f.sablon_kod)) m.set(f.sablon_kod, f.nev);
    return Array.from(m.entries()).map(([kod, nev]) => ({ kod, nev }));
  }

  // Cégenkénti nézet sorai (a "csak hátralévő" a Beadva-hiányra szűr).
  get cegSorok() { return this.tarolva('ceg', [this.terv, this.csakHatra, this.valtozas], () => this.cegSorokSzamol()); }
  private cegSorokSzamol() {
    if (!this.csakHatra) return this.terv.sorok || [];
    return (this.terv.sorok || [])
      .map((r: any) => ({ ...r, feladatok: r.feladatok.filter((f: any) => !f.teljesitve) }))
      .filter((r: any) => r.feladatok.length);
  }

  // Fordított nézet: nyomtatványonként csoportosítva, az érintett cégekkel. Ugyanazokra a
  // feladat-objektumokra hivatkozunk (közös referencia), így a pipa mindkét nézetben frissül.
  get nyomtatvanySorok() {
    return this.tarolva('nyomt', [this.terv, this.csakHatra, this.szurtSablon, this.valtozas], () => this.nyomtatvanySorokSzamol());
  }
  private nyomtatvanySorokSzamol() {
    const map = new Map<string, any>();
    for (const sor of (this.terv.sorok || [])) {
      for (const f of sor.feladatok) {
        if (this.csakHatra && f.teljesitve) continue;
        if (this.szurtSablon && f.sablon_kod !== this.szurtSablon) continue;
        let g = map.get(f.sablon_kod);
        if (!g) { g = { sablon_kod: f.sablon_kod, nev: f.nev, tetelek: [] }; map.set(f.sablon_kod, g); }
        g.tetelek.push({ ugyfel_id: sor.ugyfel_id, ceg: sor.nev, f });
      }
    }
    return Array.from(map.values()).filter((g) => g.tetelek.length);
  }

  async toggle(ugyfelId: string, f: any, mezo: 'beadva' | 'nyugta' | 'email' | 'offline') {
    const [flag, dcol] = this.FLAG[mezo];
    const uj = !f[flag];
    try {
      await this.naplo.post('/munkaterv/teljesit', {
        intezmeny: this.intezmeny, ugyfel_id: ugyfelId, sablon_kod: f.sablon_kod, idoszak: f.idoszak, mezo, ertek: uj,
      });
      f[flag] = uj;
      f[dcol] = uj ? new Date().toISOString().slice(0, 10) : null;
      this.valtozas++;   // a tárolt nézet-sorok újraszámolása (a „csak hátralévő” szűrés a pipán múlik)
      // a fejléc Kész/Hátra számláló csak a "beadva" állapotot követi (a backend így számol)
      if (mezo === 'beadva') { this.terv.kesz += uj ? 1 : -1; this.terv.hatra = this.terv.osszes - this.terv.kesz; }
      const cimke = { beadva: 'Beadva', nyugta: 'Nyugta', email: 'Email', offline: 'Offline' }[mezo];
      (await this.toast.create({ message: uj ? cimke + ' jelölve.' : cimke + ' visszavonva.', duration: 1100, color: uj ? 'success' : 'medium' })).present();
    } catch {
      (await this.toast.create({ message: 'Nem sikerült menteni.', duration: 2200, color: 'danger' })).present();
    }
  }
}
